/* eslint-disable brace-style */
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  AbstractDialog,
  AbstractDialogData,
  AbstractDialogResultData,
} from '@next/core-lib/dialog';

import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';

import { RequestsOverviewModel } from '../../../overview/models/overview.model';
import * as RequestsOverviewSlideActions from '../store/requests-overview-slide.actions';

interface RequestsOverviewDialogData extends AbstractDialogData {
  selectedRequest?: RequestsOverviewModel;
}
@Component({
  selector: 'app-requests-overview-slide',
  templateUrl: './requests-overview-slide.component.html',
  styleUrls: ['./requests-overview-slide.component.scss'],
  standalone: false,
})
export class RequestsOverviewSlideComponent
  extends AbstractDialog<RequestsOverviewDialogData>
  implements OnInit, OnDestroy
{
  data = inject<RequestsOverviewDialogData>(MAT_DIALOG_DATA);
  mdDialogRef =
    inject<
      MatDialogRef<
        RequestsOverviewSlideComponent,
        AbstractDialogResultData<RequestsOverviewDialogData>
      >
    >(MatDialogRef);
  private readonly store = inject(Store);

  intermediaries: string[] = [];

  readonly destroy$ = new Subject<void>();
  ngOnInit(): void {
    this.data.disableClose = true;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  makeMatch() {
    this.store.dispatch(
      RequestsOverviewSlideActions.requestMakeMatch({
        requestId: this.data.selectedRequest.id,
      }),
    );
    this.mdDialogRef.close();
  }
}
